/**
* @author Sai Prasad
* @class MaintenanceGuideForm
**/

/**
 * Created By: Sai Prasad
 * Created Date: 23/12/2022
 * Jira Ticket: JUN-3513
 * Description: Maintenance reminder implementation
 */

import React, { useState } from 'react'
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Input from '../Input';
import Picker from '../Picker';
import Row from '../Row';
import Toggle from '../Toggle';
import Toast from '../Toast/Toast';
import { selectFndFormData } from '../../store/selectors/fndForm';
import { useDispatch, useSelector } from 'react-redux';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm'
import Select from 'react-select';

import TextEditor from '../Editor/Editor';
import { repeatTypes, repeatEveryTypes, repeatHours } from '../../common/constants';
import { fetchRepeatHours } from '../../helpers/validationHelper';
import Checkbox from '../Checkbox';
import { variables } from '../../Tenants';

const MaintenanceGuideForm = ({
  onClose, breadcrumb, onSaveMaintenanceGuide
}) => {
  const dispatch = useDispatch();
  const fndForm = useSelector(state => selectFndFormData(state));
  
  const [editorState, setEditorState] = useState(fndForm.body ? fndForm.body : '');
  const [buttonPressed, setButtonPressed] = useState('');
  const repeatHours = fetchRepeatHours();

  const repeatType  = fndForm?.repeatType ? {value: fndForm.repeatType, label: fndForm.repeatType} : {value: "Repeat", label: "Repeat"};
  const repeatEvery = fndForm?.repeatEvery ? {value: fndForm.repeatEvery, label: fndForm.repeatEvery} : {};
  const repeatTypeEvery= fndForm?.repeatTypeEvery ? {value: fndForm.repeatTypeEvery, label: fndForm.repeatTypeEvery} : {};


  const saveMaintenanceGuide = (fndForm) => {
    let updatedData = fndForm;
    if(updatedData.appointment) {
      if(updatedData.repeatType !== 'Custom') {
        const {repeatEvery, repeatTypeEvery, ...rest} = updatedData;     
        updatedData = rest;
      }
     } else {
       const {repeatEvery, repeatTypeEvery, repeatType, ...rest} = updatedData;     
        updatedData = rest;
     }
    onSaveMaintenanceGuide(updatedData);
    if (buttonPressed === 'SaveAndAdd') {
      dispatch(clearFndFormData());
      setEditorState('');
    } else {
      onClose();
    }
  }

  const onEditorChange = (editorState) => {
    setEditorState(editorState);
    dispatch(setFndFormData({
      body: editorState
    }))
  }

  const buttonDisabled = () => {
    if (fndForm.appointment && fndForm.repeatType === "Custom") {
      return !fndForm.title || !editorState || (fndForm.IsSuiteWarrantyStartDate === false && !fndForm.appointment.date ) || !fndForm.appointment.time || !fndForm.repeatEvery || !fndForm.repeatTypeEvery
    } else if(fndForm.appointment) {
      return !fndForm.title || !editorState || (fndForm.IsSuiteWarrantyStartDate === false && !fndForm.appointment.date )|| !fndForm.appointment.time || !fndForm?.repeatType
    } else {
      return !fndForm.title || !editorState
    }
  }
  
  const setToggle = (value) => {
    if(value === false) {
      dispatch(setFndFormData({
        repeatEvery: '',
        repeatType: '',
        repeatTypeEvery: '',
        IsSuiteWarrantyStartDate:false,
      }));
    }
    dispatch(setFndFormData({ appointment: !value, toggle: !value }))
  }

  return (
    <Form
      headline={(fndForm.id ? "Edit" : "Add") + " a Maintenance Reminder"}
      onClose={() => onClose()}
      onSubmit={() => saveMaintenanceGuide(fndForm, buttonPressed)}
      actions={(
        <>
          {fndForm.id ? <div /> : <Button
            color="semantic"
            size="small"
            label="Save and Add Another"
            onClick={() => setButtonPressed('SaveAndAdd')}
            disabled={buttonDisabled()}
          />}
          <Button
            color="teal"
            size="small"
            label="Save Maintenance Reminder"
            onClick={() => setButtonPressed('SaveAndClose')}
            disabled={buttonDisabled()}
          />
        </>
      )}
      component={(
        <>
          <Row mdCenter>
            <Col
              xs="12"
              md="12"
              lg="10"
            >
              {breadcrumb && (
                <>
                  <Toast
                    message={(
                      <>
                        You are adding a Maintenance Reminder Note to <strong>{breadcrumb}</strong>.
                        </>
                    )}
                  />
                  <br />
                  <br />
                </>
              )}

              <Input
                value={fndForm.title}
                onChange={e => dispatch(setFndFormData({ title: e.target.value }))}
                label="Subject"
                placeholder="Subject"
                block
              />
              <div className="input">
                <div className="input__require">
                  <label className="input__label">Description</label>
                  <div className="input__required" />
                </div>

                <div class style={{ borderBottom: '0.1rem solid rgba(83, 83, 83, 0.25)' }} className="input__control">
                  <TextEditor
                    editorState={editorState}
                    onEditorStateChange={onEditorChange}
                  />
                </div>
              </div>
              <Toggle
                label="Set a Reminder"
                value={fndForm.appointment}
                onToggle={(value) => setToggle(value)}
              />
              {fndForm.appointment && (
                <>
                  <Row>
                    <Col
                      xs="12"
                      md="12"
                    >
                      <div className='reminderDatas' style={{width:'20%'}}>
                        <Checkbox label={`${variables.Suite} warranty start date`} value={fndForm?.IsSuiteWarrantyStartDate} onChange={()=>dispatch(setFndFormData({...fndForm,IsSuiteWarrantyStartDate:!fndForm?.IsSuiteWarrantyStartDate}))}/>
                      </div>
                      <div className='reminderDatas'>
                        {
                        (fndForm?.IsSuiteWarrantyStartDate === false || fndForm?.isSuiteWarrantyStartDate === false) ?
                        <Picker
                          minDate={new Date()}
                          showPopperArrow={false}
                          placeholderText="Date"
                          selected={(fndForm?.IsSuiteWarrantyStartDate === false || fndForm?.isSuiteWarrantyStartDate === false)? fndForm.appointment.date instanceof Date && !isNaN(fndForm.appointment.date) ? fndForm.appointment.date : null:null}
                          onChange={date => dispatch(setFndFormData({ ...fndForm, appointment: { ...fndForm.appointment, date } }))}
                        />                        
                        :null
                      }
                      </div>
                      <div className='reminderDatas'>
                        <Picker
                          placeholderText="Time"
                          showPopperArrow={false}
                          selected={fndForm.appointment.time instanceof Date && !isNaN(fndForm.appointment.time) ? fndForm.appointment.time : null}
                          onChange={time => dispatch(setFndFormData({ ...fndForm, appointment: { ...fndForm.appointment, time } }))}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                        />
                      </div>
                      <div className='reminderWeekMob'>
                      <Row>
                      <div className='reminderWeek' style={{width: '26.8%'}}>
                        <Select
                          menuPlacement="top"
                          value={repeatType}
                          onChange={data => dispatch(setFndFormData({ repeatType : data.value }))}
                          options={repeatTypes.map(type => ({ value: type, label: type}))}
                        />
                      </div>
                      {fndForm.repeatType === "Custom" &&
                      <>
                      <div className='repeatEveryText' style={{textAlign: 'center', width: '26.8%'}}> Repeat every </div>
                      <div className='reminderWeek' style={{width: '16.8%'}}>
                        <Select
                          menuPlacement="top"
                          value={repeatEvery}
                          onChange={data => dispatch(setFndFormData({ repeatEvery : data.value }))}
                          options={repeatHours.map(type => ({ value: type, label: type}))}
                          placeholder="Repeat"
                        />
                      </div>
                      <div className='reminderWeek' style={{width: '26.6%', marginLeft:'3%'}}>
                        <Select
                          menuPlacement="top"
                          value={repeatTypeEvery}
                          onChange={data => dispatch(setFndFormData({ repeatTypeEvery : data.value }))}
                          options={repeatEveryTypes.map(type => ({ value: type, label: type}))}
                        />
                      </div>
                      </>}
                      
                      </Row>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </>
      )}
    />
  )
}

export default MaintenanceGuideForm;